import { createUrqlClient } from '@hopin-team/dashboard-shared';
import { Client, OperationContext } from 'urql';

import packageJson from '../../package.json';

export const urqlClient: Client = createUrqlClient('', packageJson.name);

export const getUrqlFetchOptions = (
  authToken: string,
): OperationContext['fetchOptions'] => {
  return {
    headers: {
      authorization: `Bearer ${authToken}`,
      'X-HOPIN-CLIENT-NAME': packageJson.name,
      'X-HOPIN-CLIENT-VERSION': packageJson.version,
      'x-hopin': '1',
    },
  };
};
